import React, { useState, Fragment, useEffect } from 'react'
import { Row, Col, Button, Form, FormText } from 'react-bootstrap'
import { Table } from 'reactstrap'
import {
  prefix,
  extractData,
  notify,
} from '../../../utils/index_tagging_tool'
import {
  api
} from '../../../utils/index'
import DimensionGroup from "./DimensionGroup";
import {createDimensionGroup} from "../../api_methods";
import Loading from "../../components/Loading";
/**
 Componente simile alla sua controparte di listing presente nei report, con un livello in più (i gruppi) e senza la possibilità di modifica di bq_mode/linking
 Oltre a una dimensione, consente la creazione di un gruppo
 */
function DimensionGroupListing({ savedDimensions, groups, groupsData, language }) {
  // ForceUpdate
  const reloadListing = React.useReducer(() => ({}), {})[1]

  // Variabili di stato per la creazione di un nuovo gruppo
  const [groupName, setGroupName] = useState('')
  const [groupNameValid, setGroupNameValid] = useState('')
  const [groupNameError, setGroupNameError] = useState('')
  // Booleano per la creazione di un nuovo gruppo
  const [loadingGroup, setLoadingGroup] = useState(false)

  // Variabili di stato per la creazione di una nuova dimensione salvata
  const [selectedGroup, setSelectedGroup] = useState(groups[0])
  const [dimName, setDimName] = useState('')
  const [dimNameValid, setDimNameValid] = useState(null)
  const [dimNameError, setDimNameError] = useState(null)
  // Booleano per la creazione di una nuova dimensione salvata
  const [loadingDim, setLoadingDim] = useState(false)

  useEffect(() => {
    // Quando cambia la lunghezza dei gruppi ho fatto un'aggiunta o una rimozione, alchè devo resettare gli indicatori di correttezza dei gruppi
    setGroupName('')
    setGroupNameError('')
    setGroupNameValid('')
  }, [groups.length])

  useEffect(() => {
    // Quando cambia la lunghezza dei gruppi ho fatto un'aggiunta o una rimozione, alchè devo resettare gli indicatori di correttezza dei gruppi
    setDimName('')
    setDimNameError('')
    setDimNameValid('')
  }, [savedDimensions.length])

  const changeGroupName = (e) => {
    // Handler dell'inserimento del nome di un gruppo da parte dell'utente
    setGroupName(e.target.value)
    setGroupNameError('')
    setGroupNameValid('')
    if (groups.filter((g) => e.target.value === g).length > 0)
      setGroupNameError('Gruppo già presente')
    else if (e.target.value === '')
      setGroupNameError('Non puoi inserire un nome vuoto')
    else setGroupNameValid('Il nome inserito è valido')
  }

  const changeDimName = (e) => {
    // Handler dell'inserimento del nome di una dimensione da parte dell'utente
    setDimName(e.target.value)
    setDimNameError('')
    setDimNameValid('')
    // Controllo se esiste una dimensione salvata, associata allo stesso gruppo, il cui nome (a cui va aggiunto il gruppo tra parentesi) è identico al nome scelto
    if (
      savedDimensions
        .filter((dim) => dim.group === selectedGroup)
        .map((x) => x.display_name.toLowerCase())
        // Da fare un piccolo accrocchio dovuto sempre al fatto che le saved dimension arrivano col nome del gruppo da serializer
        .includes(`${e.target.value} (${selectedGroup})`.toLowerCase())
    ) {
      setDimNameError('Dimensione già presente nel gruppo')
    } else if (e.target.value === '')
      setDimNameError('Non puoi inserire un nome vuoto')
    else setDimNameValid('Il nome inserito è valido')
  }

  // Funzione che contatta il backend per l'inserimento di un nuovo gruppo, dando feedback all'utente con notify
  const handleAddGroup = (e) => {
    e.preventDefault()
    setLoadingGroup(true)

    let formData = new FormData()
    formData.append('name', groupName)

    createDimensionGroup(formData).then((data) => {
      if (typeof data !== 'string')
        notify('Esiste già un gruppo con questo nome', 'warning')
      else {
        notify('Gruppo aggiunto', 'success')
        groups.push(groupName)
        reloadListing()
      }
      setLoadingGroup(false)
    })
      .catch((error) => {
        console.log(error)
        notify(
          error.message,
          'error'
        )
        setLoadingGroup(false)
      })
  }

  // Funzione che contatta il backend per l'inserimento di una nuova dimensione salvata, dando feedback all'utente con notify
  const handleAddDim = (e) => {
    e.preventDefault()

    setLoadingDim(true)

    let formData = new FormData()
    formData.append('nome', dimName)
    formData.append('nomeColonna', dimName)
    formData.append('gruppo', selectedGroup)

    api.post(prefix + 'saved-dimensions/', formData)
      .then(extractData)
      .then((data) => {
        if (typeof data !== 'object')
          notify('Esiste già una dimensione con questo nome', 'warning')
        else {
          notify(`Dimensione aggiunta al gruppo ${selectedGroup}`, 'success')
          savedDimensions.push(data)
        }
        setLoadingDim(false)
      })
      .catch((error) => {
        console.log(error)
        notify(
          error.message,
          'error'
        )
        setLoadingDim(false)
      })
  }

  return (
    <Row>
      <Col md={6}>
        <Table striped responsive>
          <thead>
            <tr>
              <th>
                Nome
              </th>
              <th>
                N° Dimensioni
              </th>
              <th>
                Modifica
              </th>
            </tr>
          </thead>
          <tbody>
          {groupsData ? groupsData.filter((x) => x.is_sub === false).map((g) => (
            <DimensionGroup
              group={g}
              savedDimensions={savedDimensions}//.filter((x) => x.group.name === g.name)
              key={g.name}
              reloadListing={reloadListing}
            />
          )) : <Loading/>}
          </tbody>
        </Table>
      </Col>
      <Col md={6}>
        <Form>
          <Row className={'mb-5 mt-5 ml-5'}>
            <Col xs={7}>
              <Form.Control
                type="text"
                isValid={groupNameValid}
                isInvalid={groupNameError}
                value={groupName}
                onChange={changeGroupName}
              />
              {groupNameError !== '' && (
                <FormText style={{ color: 'red' }} align={'left'}>
                  {groupNameError}
                </FormText>
              )}
              {groupNameValid !== '' && (
                <FormText style={{ color: 'green' }} align={'left'}>
                  {groupNameValid}
                </FormText>
              )}
            </Col>
            <Col xs={4}>
              {loadingGroup ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <Button
                  type="submit"
                  variant="warning"
                  disabled={groupNameError || groupName === ''}
                  className="px-0"
                  style={{ width: '100%' }}
                  onClick={handleAddGroup}
                >
                  Aggiungi gruppo
                </Button>
              )}
            </Col>
          </Row>
          <Row className={'mb-5 ml-5'}>
            <Col xs={3}>
              <Form.Control
                as="select"
                value={selectedGroup}
                onChange={(e) => setSelectedGroup(e.target.value)}
              >
                {groups.map((g, i) => (
                  <option key={i} value={g}>
                    {g}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col xs={4}>
              <Form.Control
                type="text"
                isValid={dimNameValid}
                isInvalid={dimNameError}
                value={dimName}
                onChange={changeDimName}
              />
              {dimNameError !== '' && (
                <FormText style={{ color: 'red' }} align={'left'}>
                  {dimNameError}
                </FormText>
              )}
              {dimNameValid !== '' && (
                <FormText style={{ color: 'green' }} align={'left'}>
                  {dimNameValid}
                </FormText>
              )}
            </Col>
            <Col xs={4}>
              {loadingDim ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                <Button
                  type="submit"
                  variant="warning"
                  disabled={dimNameError || dimName === ''}
                  className="px-0"
                  style={{ width: '100%' }}
                  onClick={handleAddDim}
                >
                  Aggiungi dimensione
                </Button>
              )}
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}

export default DimensionGroupListing
